import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { initialSquareGridSettings } from 'src/app/services/helper/plotly-helper';

@Component({
    selector: 'app-two-directions-percentage-square-grid',
    templateUrl: './two-directions-percentage-square-grid.component.html',
    styleUrls: ['./two-directions-percentage-square-grid.component.scss'],
})
export class TwoDirectionsPercentageSquareGridComponent implements OnInit, OnChanges {
    @Input() _x?: number;
    @Input() _y?: number;
    @Input() _dimension?: number;

    private x: number = 0;
    private y: number = 0;

    public plotSettings;

    constructor() {
        this.plotSettings = JSON.parse(JSON.stringify(initialSquareGridSettings));
    }

    ngOnInit(): void {
        this.plotSettings.data[0].x = [this.x];
        this.plotSettings.data[0].y = [this.y];
        this.initSquareGrid();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ('_x' in changes && changes['_x'].currentValue !== undefined) {
            this.x = changes['_x'].currentValue;
            this.updateGridData();
        }
        if ('_y' in changes && changes['_y'].currentValue !== undefined) {
            this.y = changes['_y'].currentValue;
            this.updateGridData();
        }
    }

    initSquareGrid() {
        if (this._dimension !== undefined) {
            this.plotSettings.layout.width = this._dimension;
            this.plotSettings.layout.height = this._dimension;
        }
    }

    updateGridData() {
        this.plotSettings.data[0].x = [this.x];
        this.plotSettings.data[0].y = [this.y];
    }
}
